import { FullMetadata } from '@firebase/storage';

import { ISanitizedCompany } from 'types/company';
import { IUserResponse } from 'types/user';

import { getShortUniqueId } from './uniqueId';

export interface StoryFromFile {
  id: string;
  meta: {
    userId: string;
    companyId: string;
  };
  files: {
    path: string;
    name: string;
    link: string;
    type: string;
  }[];
  style: string;
}

export const storyFromFileFactory = (
  user: IUserResponse,
  company: ISanitizedCompany,
  meta: FullMetadata,
  link: string,
  style: string,
): StoryFromFile => {
  return {
    id: getShortUniqueId(),
    meta: {
      userId: user.uid,
      companyId: company.id,
    },
    files: [
      { path: meta.fullPath, name: meta.name, link, type: meta.contentType! },
    ],
    style,
  };
};
